module.exports = __webpack_public_path__ + "static/media/header-worksessions-052123.54d25d47.png";